import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import LiveTvProgressBar, {
  Props as LiveTvProgressBarProps
} from '@smart-tv/components/live-tv-progress-bar/live-tv-progress-bar';

import styles from './content-item.module.scss';

interface Props extends LiveTvProgressBarProps {
  liveTV: boolean;
}

export const ContentItemProgressBar: React.FC<Props> = (props: Props) => {
  const { liveTV, ...rest } = props;

  return liveTV ? (
    <LiveTvProgressBar
      className={styles['live-tv-progress-bar']}
      data-testid={testIds.contentItem.progress}
      {...rest}
    />
  ) : (
    <LiveTvProgressBar
      className={styles['progress-bar']}
      data-testid={testIds.contentItem.progress}
      {...rest}
    />
  );
};

export default React.memo(ContentItemProgressBar);
